<div class="p-a-xl">
    <cipo-formula-definition [fields]="fields"></cipo-formula-definition>
</div>